module.exports = __webpack_public_path__ + "159d9a29b453d4977517252468b1e9f5.svg";